export function useMapConsigneeContact(contact, modelValue) {

    modelValue.consignee.consigneeContactId = contact.id;
    modelValue.consignee.consigneeContactTitle = contact.title;
    modelValue.consignee.consigneeContactFirstName = contact.firstName;
    modelValue.consignee.consigneeContactLastName = contact.lastName;
    modelValue.consignee.consigneeContactPhone = contact.phone;
    modelValue.consignee.consigneeContactEmail = contact.email;
}
